<template>
  <div class="comp-full-calendar">
    <t-calendar-header :date="localeDate" @change-month="$_changeMonth" @change-year="$_changeYear"></t-calendar-header>
    <t-calendar-body :date="localeDate" :this-date="thisDate" :week-days="weekDays"></t-calendar-body>
  </div>
</template>

<script>
import TCalendarHeader from './calendar-header'
import TCalendarBody from './calendar-body'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import calendar from 'dayjs/plugin/calendar'

dayjs.extend(calendar)

export default {
  name: 'TCalendar',
  components: {
    TCalendarHeader,
    TCalendarBody
  },
  provide() {
    return {
      calendar: this
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    locale: {
      type: [String, Object],
      default: 'zh-cn',
      validator(val) {
        if (typeof val === 'string') {
          return ['en', 'zh-cn'].includes(val)
        }
        return true
      }
    }
  },
  data() {
    return {
      today: this.value ? dayjs(this.value) : dayjs(),
      currentVal: this.value ? dayjs(this.value) : dayjs()
    }
  },
  computed: {
    localeDate() {
      return typeof this.locale === 'string'
        ? this.currentVal.locale(this.locale)
        : this.currentVal.locale(this.locale, null, true)
    },
    thisDate() {
      return typeof this.locale === 'string'
        ? this.today.locale(this.locale)
        : this.today.locale(this.locale, null, true)
    },
    weekDays() {
      return this.localeDate.$locale().weekdaysShort
    }
  },
  methods: {
    $_changeMonth(val) {
      this.currentVal = this.currentVal.month(val - 1)
      this.$emit('change-month', this.currentVal)
    },
    $_changeYear(val) {
      this.currentVal = this.currentVal.year(val)
      this.$emit('change-year', this.currentVal)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/module/calendar/calendar.vue